import { useCallback } from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './noticeModal.module.scss';

const cx = classnames.bind(styles);

interface NoticeModalProps {
  useYn: boolean;
  type: 'SMS' | 'EMAIL';
  onClose: () => void;
  onConfirm: () => void;
}

const NoticeModal = ({ useYn, type, onClose, onConfirm }: NoticeModalProps) => {
  const state = useYn ? 'ON' : 'OFF';

  const getNoticeTarget = useCallback(() => {
    switch (type) {
      case 'SMS':
        return 'SMS';
      case 'EMAIL':
        return '이메일';
    }
  }, []);

  const noticeTarget = getNoticeTarget();

  return (
    <Modal visible={true}>
      <div className={cx('layerNotice')}>
        <span className={cx('title')}>
          <em className={cx('emphasis')}>
            {noticeTarget} 알림 수신을 {state}
          </em>{' '}
          하시겠습니까?
        </span>
        <p className={cx('desc')}>
          {useYn && <>{"알림 수신을 ON할 시 '마케팅 수신 동의'가 진행됩니다. "}</>}
          {!useYn && (
            <>
              잠깐! 알림 수신을 OFF 하면 채용정보와 기업소식이
              <br />더 이상 제공되지 않습니다.
            </>
          )}
        </p>
        <div className={cx('btnArea')}>
          <button className={cx('btn', 'btnConfirm')} onClick={onConfirm}>
            확인
          </button>
          <button className={cx('btn', 'btnCancel')} onClick={onClose}>
            나중에 하기
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default NoticeModal;
